export const getAlertProperties = (alertData: {
  id: string;
  source_id: string;
  source_type: string;
  created_at: string;
}) => ({
  alert_id: alertData.id,
  source_id: alertData.source_id,
  alert_type: alertData.source_type,
  alert_age_seconds: Math.floor(
    (Date.now() - new Date(alertData.created_at).getTime()) / 1000
  ),
});
